import {
  initialState,
  Actions,
  State,
  SHOW_CONTENT,
  SHOW_CONTENT_SUCCESS,
  SHOW_CONTENT_ERROR,
  RESET_SHOW_CONTENT,
} from '../../types/content/show'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SHOW_CONTENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case SHOW_CONTENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case SHOW_CONTENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_SHOW_CONTENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
